(function() {
	'use strict';

	angular.module('quantixApp').controller('userupdatedata', userupdatedata);

	userupdatedata.$inject = [ '$scope', 'Principal', '$state', '$location',
			'UserActivityService', 'userupdatedataService', '$uibModal',
			'$rootScope', '$timeout', '$q', '$http', '$stateParams',
			'GenericService','ErrorHandlerService' ];

	function userupdatedata($scope, Principal, $state, $location,
			UserActivityService, userupdatedataService, $uibModal, $rootScope,
			$timeout, $q, $http, $stateParams, GenericService,ErrorHandlerService) {

		$scope.portfolioId = $stateParams.portfolioId;
		$scope.portfolioType=$stateParams.portfolioType;
		$scope.portfolioDateTime=$stateParams.portfolioDateTime;
		if ($stateParams.portfolioId == null
				|| !angular.isDefined($stateParams.portfolioId)) {
			$state.go('portfolioDashboard')
		}
		$scope.selectedPortName= $stateParams.portfolioName;
		
		$scope.ratingSummary;
		$scope.ratingSummaryProperties;
		$scope.ratingSummaryUser;
		$scope.ratingSummaryUniv;
		$scope.locationBased;
		$scope.industryBased;
		$scope.internalRatingBased;
		$scope.weightedInternalRating;
		GenericService.getUserModuleAccessData().then(function(result){
			$scope.userModuleAccessData = result;
		});
		var sectionaccess = {};
		GenericService.getUserSectionAccessData().then(function(result){
			sectionaccess = result;
			if (sectionaccess['Portfolio View.User Updated Details'] != 'Y') {
				ErrorHandlerService.forbiddenErrorForDetailForPortFolio("User Update Data",$scope.portfolioId,$scope.selectedPortName,$scope.portfolioType,$scope.portfolioDateTime);
				return;
			}
		});		
		function getUserPortfolio() {
			userupdatedataService
					.getUserPortfolio($scope.portfolioId)
					.then(
							function(result) {
								$scope.ratingSummary = result.ratingSummary;
								$scope.ratingSummaryProperties = $scope.ratingSummary.properties;
								// $scope.ratingSummaryUser
								// =$scope.ratingSummary.user;
								// $scope.ratingSummaryUniv
								// =$scope.ratingSummary.univ;
								$scope.locationBased = result.locationBased;
								$scope.industryBased = result.industryBased;
								$scope.internalRatingBased = result.internalRatingBased;
								$scope.weightedInternalRating = result.weightedInternalRating;
								$scope.weightedExternalRating = result.weightedExternalRating;
								$scope.summaryClientCode = result.summaryClientCode;
								$scope.summaryConstituent = result.summaryConstituent;
								

							});

		}

		if ($stateParams.portfolioId != null
				|| angular.isDefined($stateParams.portfolioId)) {
			getUserPortfolio();
		}
		

		$scope.getBackToPortfolioDetails=function(){
			$state.go('portfolioLanding', {
				'portfolioId' : $scope.portfolioId,
				'portfolioName' : $scope.selectedPortName,
				'portfolioType' : $scope.portfolioType,
				'portfolioDateTime': $scope.portfolioDateTime
			});
		}
		$scope.userError=false;
		$scope.userPortfolioExport = function() {
			 if (sectionaccess["Portfolio View.Export Credit Portfolio"] != 'Y') {
					$scope.errorMessages = 'This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.';
					$scope.userError=true;
					
					$timeout(function() {
						$scope.errorMessages = '';
						$scope.userError=false;

					}, 2000);
				}else{
			$scope.exportInputDTO = {
				userPortfolioId : $scope.portfolioId,
				portfolioName : $scope.selectedPortName
			};
			$http({
				url : 'api/portfolio/portfolioUserExportData',
				method : 'POST',
				data : $scope.exportInputDTO,
				responseType : 'arraybuffer'
			})
					.success(
							function(response) {
								var isIE = false || !!document.documentMode;
								$scope.response = response;
								var blob = new Blob(
										[ response ],
										{
											type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
										});
								if (isIE) {

									window.navigator
											.msSaveOrOpenBlob(blob,
													'CreditUserPortfolio_Template.xlsx');

								} else {

									var anchor = angular.element('<a/>');
									var blob = new Blob([ response ], {
										type : 'application/vnd.ms-excel'
									})
									var objectUrl = (window.URL || window.webkitURL)
											.createObjectURL(blob);
									anchor.css({
										display : 'none'
									});
									// Make sure it's not visible
									angular.element(document.body).append(
											anchor); // Attach to document
									anchor
											.attr({
												href : objectUrl,
												target : '_self',

												download : 'CreditUserPortfolio_Template.xlsx'
											})[0].click();

									anchor.remove();

								}

							});
		}
		}
	}

})();
